import { render } from "./loader-load.vue?vue&type=template&id=2bba3a64&scoped=true"
const script = {}

import "./loader-load.vue?vue&type=style&index=0&id=2bba3a64&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bba3a64"]])

export default __exports__